import i18n from '../../i18n';

const PASSWORD_MIN_LENGTH = 8;

export default function validatePassword(password) {
  let valid = true;
  let error = null;

  if(!password) {
    valid = false;
    error = i18n.t('errors:PASSWORD_REQUIRED');
  } else if(password.length < PASSWORD_MIN_LENGTH) {
    valid = false;
    error = i18n.t('errors:PASSWORD_TOO_SHORT', {len: PASSWORD_MIN_LENGTH});
  }

  return {
    valid,
    error
  }
}
